var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"div-favcities"},[_c('img',{staticClass:"img-favcities",attrs:{"src":_vm.CityFoto}}),_c('div',{staticClass:"div-favcities1"},[_vm._l((_vm.item),function(region,index){return [_c('CardSmallLocation',{attrs:{"item":region}})]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }